<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Surat Jalan Delivery" active>

                                <b-row v-if="hasFailedDataSuratJalanDelivery">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedSuratJalanDelivery.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="suratJalanDeliverysFailed" :fields="fieldsSuratJalanDelivery" :busy="isDataLoading"
                                                         :sort-by.sync="sortBySuratJalanDelivery" :sort-desc.sync="sortDescSuratJalanDelivery" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(deliveryDate)="row">
													{{ row.item.deliveryDate | moment("DD-MMM-YYYY") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedSuratJalanDelivery.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="suratJalanDeliverys" :fields="fieldsSuratJalanDelivery" :busy="isDataLoading"
                                                         :sort-by.sync="sortBySuratJalanDelivery" :sort-desc.sync="sortDescSuratJalanDelivery" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(deliveryDate)="row">
													{{ row.item.deliveryDate | moment("DD-MMM-YYYY") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Surat Jalan Delivery Detail" active>

                                <b-row v-if="hasFailedDataSuratJalanDeliveryDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedSuratJalanDeliveryDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="suratJalanDeliveryDetailsFailed" :fields="fieldsSuratJalanDeliveryDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortBySuratJalanDeliveryDetail" :sort-desc.sync="sortDescSuratJalanDeliveryDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(orderQty)="row">
													{{ Number(row.item.orderQty).toLocaleString() }}
												</template>
												<template #cell(deliveryQty)="row">
													{{ Number(row.item.deliveryQty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedSuratJalanDeliveryDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="suratJalanDeliveryDetails" :fields="fieldsSuratJalanDeliveryDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortBySuratJalanDeliveryDetail" :sort-desc.sync="sortDescSuratJalanDeliveryDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(orderQty)="row">
													{{ Number(row.item.orderQty).toLocaleString() }}
												</template>
												<template #cell(deliveryQty)="row">
													{{ Number(row.item.deliveryQty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import SuratJalanDelivery from '@/models/SuratJalanDelivery/SuratJalanDelivery';
import SuratJalanDeliveryList from '@/models/SuratJalanDelivery/SuratJalanDeliveryList';
import SuratJalanDeliveryFilter from '@/filters/SuratJalanDelivery/SuratJalanDeliveryFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsSuratJalanDelivery: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Delivery Instruction", key: 'deliveryInstructionDiNumber', sortable: false},
				{"class" : "th-status", "label" : "Delivery Date", key: 'deliveryDate', sortable: false},
				{"class" : "th-status", "label" : "Apakah Sudah Dikirim?", key: 'isAlreadyDeliver', sortable: false},
				{"class" : "th-status", "label" : "Customer", key: 'customerCode', sortable: false},
				{"class" : "th-status", "label" : "Destination", key: 'destinationCode', sortable: false},
				{"class" : "th-status", "label" : "Remarks", key: 'remarks', sortable: false},
				{"class" : "th-status", "label" : "Driver Name", key: 'driverName', sortable: false},
				{"class" : "th-status", "label" : "Vehicle Number", key: 'vehicleNumber', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsSuratJalanDeliveryDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Delivery Card", key: 'deliveryCardDeliveryCardNumber', sortable: false},
				{"class" : "th-status", "label" : "Part", key: 'partPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Order Qty", key: 'orderQty', sortable: false},
				{"class" : "th-status", "label" : "Delivery Qty", key: 'deliveryQty', sortable: false},
				{"class" : "th-status", "label" : "Checklist Loading", key: 'isLoading', sortable: false},
				{"class" : "th-status", "label" : "Delivery Instruction Detail", key: 'deliveryInstructionDetailPart', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			suratJalanDeliverys : [],
			suratJalanDeliverysFailed: [],
			suratJalanDeliveryId : '',
			sortBySuratJalanDelivery: '',
			sortDescSuratJalanDelivery: '',
			hasFailedDataSuratJalanDelivery: false,
			totalFailedSuratJalanDelivery: 0,
			totalSucceedSuratJalanDelivery: 0,
			suratJalanDeliveryDetails : [],
			suratJalanDeliveryDetailsFailed: [],
			suratJalanDeliveryDetailId : '',
			sortBySuratJalanDeliveryDetail: '',
			sortDescSuratJalanDeliveryDetail: '',
			hasFailedDataSuratJalanDeliveryDetail: false,
			totalFailedSuratJalanDeliveryDetail: 0,
			totalSucceedSuratJalanDeliveryDetail: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('suratjalandelivery/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('suratjalandelivery/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getSuratJalanDeliveryForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getSuratJalanDeliveryForUpload : async function() {
			let _this = this;
			this.$http.get('suratjalandelivery/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.suratJalanDeliverys = [];
_this.suratJalanDeliveryDetails = [];


					if (response != null) {
						let result = response.data;
						_this.suratJalanDeliverys = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedSuratJalanDelivery = _this.suratJalanDeliverys.length;

						_this.suratJalanDeliverysFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataSuratJalanDelivery = true;
						_this.totalFailedSuratJalanDelivery = 0;
						if(_this.suratJalanDeliverysFailed == undefined || _this.suratJalanDeliverysFailed.length === 0) _this.hasFailedDataSuratJalanDelivery = false;
						if(_this.hasFailedDataSuratJalanDelivery) _this.totalFailedSuratJalanDelivery = _this.suratJalanDeliverysFailed.length;
						_this.suratJalanDeliveryDetails = [];
						_this.suratJalanDeliveryDetailsFailed = [];
						_this.hasFailedDataSuratJalanDeliveryDetail = true;
						_this.totalSucceedSuratJalanDeliveryDetail = 0;
						result.forEach(function(element) {
							_this.suratJalanDeliveryDetails.push(...element.suratJalanDeliveryDetail.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedSuratJalanDeliveryDetail = _this.suratJalanDeliveryDetails.length;

							_this.suratJalanDeliveryDetailsFailed.push(...element.suratJalanDeliveryDetail.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.suratJalanDeliveryDetailsFailed == undefined || _this.suratJalanDeliveryDetailsFailed.length === 0) _this.hasFailedDataSuratJalanDeliveryDetail = false;
							if(_this.hasFailedDataSuratJalanDeliveryDetail) _this.totalFailedSuratJalanDeliveryDetail = _this.suratJalanDeliveryDetailsFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'suratjalandelivery/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'SuratJalanDelivery.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterSuratJalanDelivery = new SuratJalanDeliveryFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
